export function setThemeColors(prefix="tata") {
    
    const themeMap = {
      tata: { bgColor: '#006EAF' },
      arka: { bgColor: '#409EFF' },
    };

    // Get the theme colors based on the prefix, with defaults
    const { bgColor } = themeMap[prefix] || { bgColor: 'white' };
  
    // Set CSS variables globally
    document.documentElement.style.setProperty('--bgColor', bgColor);
  }